<template>
  <q-input
    v-bind="$attrs"
    :model-value="fieldValue"
    data-test-id="router-field"
    :clickable="false"
    readonly
    bottom-slots
  >
    <template #append>
      <router-link
        v-if="!$_.isNil(link?.params?.id)"
        :to="link"
        class="text-primary text-decoration-none"
        :disable="disable"
      >
        <q-icon
          name="far fa-arrow-up-right-from-square"
          size="xs"
        />
      </router-link>
    </template>
  </q-input>
</template>

<script>

export default {
  name: 'RouterField',
  props: {
    fieldValue: {
      type: String,
      required: true
    },
    link: {
      type: Object,
      required: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
